module.exports = __webpack_public_path__ + "static/b7-195e76eff8fa8d3243ded30eb4e38e03.jpg";